import {RouteProps} from 'config/navigation';

import Segments from './segments';
import CreateSegment from './create-segment';
import EditSegment from './edit-segment';
import {FiLink} from 'react-icons/fi';

const segmentsPages: RouteProps = {
  name: 'Segmentos',
  path: 'segments',
  permission: 'segments.findAll',
  icon: <FiLink />,
  subRoutes: [
    {
      path: '',
      element: <Segments />,
      permissions: ['segments.findAll'],
    },
    {
      path: 'create',
      element: <CreateSegment />,
      permissions: ['segments.findOne'],
    },
    {
      path: ':id',
      element: <EditSegment />,
      permissions: ['segments.findOne'],
    },
  ],
};

export default segmentsPages;
